module.exports = __webpack_public_path__ + "static/img/bg-banner-case-detail-rail.a3de1333.png";